import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import AppApi from './CognitoApi';

const appApi = new AppApi();
const DEFAULT_PLANT = "wlc1";
const resolvePlant = (plant) =>
  typeof plant === "string" && plant.trim() ? plant.trim() : DEFAULT_PLANT;
const resolveCustomerId = (customerId) =>
  typeof customerId === "string" && customerId.trim()
    ? customerId.trim()
    : undefined;
const resolveAssetIdentifierKey = (assetIdentifier) =>
  typeof assetIdentifier === "string" && assetIdentifier.trim()
    ? assetIdentifier.trim().toLowerCase()
    : "";
const resolveRevenuePlant = (plant) => {
  if (!plant) {
    return "Wilson Creek (WLC1)";
  }
  const normalized = String(plant).trim();
  if (!normalized) {
    return "Wilson Creek (WLC1)";
  }
  if (normalized.toLowerCase() === "wlc1") {
    return "Wilson Creek (WLC1)";
  }
  return normalized;
};
const formatYmd = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
const getMonthToDateRange = () => {
  const end = new Date();
  const start = new Date(end.getFullYear(), end.getMonth(), 1);
  return {
    start: formatYmd(start),
    end: formatYmd(end),
  };
};
const resolveAssetId = (plant) => {
  const resolvedPlant = resolvePlant(plant);
  const parenMatch = String(resolvedPlant).match(/\(([A-Za-z0-9_-]+)\)/);
  if (parenMatch?.[1]) {
    return parenMatch[1].toUpperCase();
  }
  return String(resolvedPlant).trim().toUpperCase();
};
const normalizeTimestampKey = (value) => {
  if (!value) return '';
  return String(value)
    .trim()
    .replace('T', ' ')
    .replace(/Z$/, '')
    .replace(/\.\d+$/, '')
    .slice(0, 16);
};
const parseHistoricalPoolPriceRows = (raw) => {
  if (!raw) return [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    const rows = Array.isArray(parsed?.data) ? parsed.data : [];
    return rows
      .map((row) => ({
        datetime: row?.[0],
        poolprice: Number.parseFloat(row?.[1] ?? 0),
      }))
      .filter((row) => row.datetime);
  } catch (error) {
    console.error("Failed to parse historical pool price rows:", error);
    return [];
  }
};
const parseMeteredVolumeRows = (raw, assetId) => {
  const returns = Array.isArray(raw?.return) ? raw.return : [];
  const normalizedAssetId = String(assetId || '').trim().toUpperCase();
  const rows = [];

  returns.forEach((participant) => {
    const assetList = Array.isArray(participant?.asset_list) ? participant.asset_list : [];
    assetList.forEach((asset) => {
      const currentAssetId = String(asset?.asset_ID || '').trim().toUpperCase();
      if (normalizedAssetId && currentAssetId && currentAssetId !== normalizedAssetId) {
        return;
      }
      const meteredList = Array.isArray(asset?.metered_volume_list) ? asset.metered_volume_list : [];
      meteredList.forEach((entry) => {
        const meteredVolume = Number.parseFloat(entry?.metered_volume ?? 0);
        rows.push({
          asset_ID: currentAssetId || normalizedAssetId,
          datetime: entry?.begin_date_mpt || entry?.begin_date_utc || null,
          begin_date_mpt: entry?.begin_date_mpt || null,
          begin_date_utc: entry?.begin_date_utc || null,
          TNG: Number.isFinite(meteredVolume) ? meteredVolume : 0,
          metered_volume: Number.isFinite(meteredVolume) ? meteredVolume : 0,
        });
      });
    });
  });

  return rows
    .filter((row) => row.datetime)
    .sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
};
const combineMeteredVolumeWithPoolPrice = (meteredRows, poolPriceRows) => {
  const priceByTime = new Map();

  poolPriceRows.forEach((row) => {
    const key = normalizeTimestampKey(row?.datetime);
    if (!key) return;
    const poolprice = Number.parseFloat(row?.poolprice ?? 0);
    priceByTime.set(key, Number.isFinite(poolprice) ? poolprice : 0);
  });

  return meteredRows.map((row) => {
    const mptKey = normalizeTimestampKey(row.begin_date_mpt);
    const utcKey = normalizeTimestampKey(row.begin_date_utc);
    const matchedPrice = priceByTime.has(mptKey)
      ? priceByTime.get(mptKey)
      : priceByTime.get(utcKey);
    const poolprice = Number.isFinite(matchedPrice) ? matchedPrice : 0;

    return {
      datetime: row.datetime,
      begin_date_mpt: row.begin_date_mpt,
      begin_date_utc: row.begin_date_utc,
      asset_ID: row.asset_ID,
      TNG: row.TNG,
      metered_volume: row.metered_volume,
      poolprice,
      pool_price: poolprice,
    };
  });
};
  function timeSelect (data, index, start, end) {
    const currentTime = new Date()
    currentTime.setMinutes(0, 0, 0)
    const startTime = currentTime.getTime() + start * 3600000
    const endTime = currentTime.getTime() + end * 3600000
  
    var filtered = data.filter(item => {
      const itemTime = new Date(item[index]).getTime()
      return itemTime >= startTime && itemTime <= endTime
    })
    return filtered.sort((a, b) => {
      const dateA = new Date(a[index].replace(' ', 'T'));
      const dateB = new Date(b[index].replace(' ', 'T'));
      return dateA - dateB;
   });
    
  }
  function getDate (Days, type = 'date') {
    // Create a new Date object for the date from the set days from now
    const modifiedDate = new Date(new Date().getTime() + Days * 24 * 60 * 60 * 1000)
  
   //for full year

    // Get the year, month, and day from the modified date
    const year = modifiedDate.getFullYear() // Get the year
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0') // Get the month and pad with leading zero if necessary
    const day = String(modifiedDate.getDate()).padStart(2, '0') // Get the day and pad with leading zero if necessary
    const modifiedDateString = `${year}-${month}-${day}` // Format the date as "year-month-day"
  
    return modifiedDateString // Return the formatted date string
  }
  function getPast12MonthRange() {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(endDate.getFullYear(), endDate.getMonth() - 12, 1);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate() + 1).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  return {
    start: formatDate(startDate),
    end: formatDate(endDate)
  };
}
export const useRockbash = () => { //getRockbashAccuracy with API caller grabs the rockbash accuracy all time and 24 hours
  return useQuery({
    queryKey: ['rockbashLT'], 
    queryFn: async () => appApi.queryRockbashApi(13,168),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};
export const useUserRole = () => { //getRockbashAccuracy with API caller grabs the rockbash accuracy all time and 24 hours
  return useQuery({
    queryKey: ['UserRole'], 
    queryFn: async () => appApi.getUserRole(),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};
export const useUserPowerplants = () => {
  return useQuery({
    queryKey: ['UserPowerplants'],
    queryFn: async () => appApi.getUserPowerplants(),
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};
export const useRockbashAccuracy = () => { //getRockbashAccuracy with API caller grabs the rockbash accuracy all time and 24 hours
  return useQuery({
    queryKey: ['rockbashAccuracy'], 
    queryFn: async () => appApi.queryRockbashAccuracyApi(),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};
export const useMEConfig = (plant, customerId) => { //getRockbashAccuracy with API caller grabs the rockbash accuracy all time and 24 hours
  const resolvedPlant = resolvePlant(plant);
  const resolvedCustomerId = resolveCustomerId(customerId);
  return useQuery({
    queryKey: ['MEConfig', resolvedPlant, resolvedCustomerId],
    queryFn: async () => appApi.querySchedulerBotApi("bidbuilderparams", resolvedPlant, resolvedCustomerId),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};
export const useGeneratorConfig = (plant, customerId) => { //getRockbashAccuracy with API caller grabs the rockbash accuracy all time and 24 hours
  const resolvedPlant = resolvePlant(plant);
  const resolvedCustomerId = resolveCustomerId(customerId);
  return useQuery({
    queryKey: ['GeneratorConfig', resolvedPlant, resolvedCustomerId],
    queryFn: async () => appApi.querySchedulerBotApi("GeneratorAvailabilityParam", resolvedPlant, resolvedCustomerId),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};

export const useBidData = (plant) => { //getBidData API caller grabs the bid data for a plant
  const resolvedPlant = resolvePlant(plant);
  return useQuery({
    queryKey: ['bidData', resolvedPlant], 
    queryFn: async () => appApi.queryGetBidDataApi(resolvedPlant),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};
export const useRockbashAccuracyTimeSeries = () => { //getRockbashAccuracyTimeSeries with API caller grabs the rockbash accuracy For each hour
  return useQuery({
    queryKey: ['rockbashAccuracyTimeSeries'], 
    queryFn: async () => appApi.queryRockbashAccuracyTimeSeriesApi(),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
};
export const useAilDemand = () => {
  return useQuery({
    queryKey: ['AILDemand'],
    queryFn: async () => {
      const response = await appApi.queryAILApi();
      if (!response) return null;
      const body = response.body ?? response;
      if (typeof body === "string") {
        try {
          return JSON.parse(body);
        } catch (error) {
          console.error("Failed to parse AIL demand body:", error);
          return null;
        }
      }
      return body;
    },
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};
export const useAlarmData = () => {
  return useQuery({
    queryKey: ['AlarmData'],
    queryFn: async () => appApi.queryAlarmApi(),
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};
export const usePowerplantStatus = (assetIdentifier, customerId) => {
  const assetKey = resolveAssetIdentifierKey(assetIdentifier);
  const resolvedCustomerId = resolveCustomerId(customerId);
  return useQuery({
    queryKey: ['PowerplantStatus', assetKey, resolvedCustomerId],
    enabled: Boolean(assetKey),
    queryFn: async () => {
      const response = await appApi.querySchedulerBotApi(
        "powerplantstatus",
        assetKey,
        resolvedCustomerId
      );

      if (response == null) return null;

      // `schedulerbotConfig` may return a raw "0"/"1", a number, or a nested object/stringified JSON.
      let value = response;
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === "0" || trimmed === "1") {
          return trimmed === "1";
        }
        try {
          const parsed = JSON.parse(trimmed);
          value = parsed?.value ?? parsed?.powerplantstatus ?? parsed;
        } catch (error) {
          return null;
        }
      }

      if (typeof value === "number") {
        return value === 1;
      }
      if (typeof value === "boolean") {
        return value;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === "0" || trimmed === "1") {
          return trimmed === "1";
        }
      }
      if (value && typeof value === "object") {
        const nested = value.value ?? value.powerplantstatus ?? value.status ?? null;
        if (nested === "1" || nested === 1 || nested === true) return true;
        if (nested === "0" || nested === 0 || nested === false) return false;
      }

      return null;
    },
    staleTime: 1000 * 60,
    retry: 2,
  });
};
export const useOperationsData = (asset) => {
  return useQuery({
    queryKey: ['OperationsData', asset],
    queryFn: async () => {
      if (!asset) return null;
      const response = await appApi.queryOperationsApi(asset);
      if (!response) return null;
      const body = response.body ?? response;
      if (typeof body === "string") {
        try {
          return JSON.parse(body);
        } catch (error) {
          console.error("Failed to parse operations data body:", error);
          return null;
        }
      }
      return body;
    },
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};

export const useRunningRebootTargets = () => {
  return useQuery({
    queryKey: ['RunningRebootTargets'],
    queryFn: async () => {
      const response = await appApi.getRunningRebootTargets();
      if (!response) return [];
      const body = response.body ?? response;
      const parsed = typeof body === 'string' ? JSON.parse(body) : body;
      const instances = Array.isArray(parsed?.matched_instances) ? parsed.matched_instances : [];
      return instances;
    },
    staleTime: 1000 * 30,
    retry: 1,
  });
};
export const useMonthlyGenerationRevenue = () => {
  return useQuery({
    queryKey: ['MonthlyGenerationRevenue'],
    queryFn: async () => appApi.queryMonthlyGenApi(),
    staleTime: 1000 * 60 * 10,
    retry: 2,
  });
};
export const useShortTermForecast = () => { // this grabs the current days forecast for both aeso and rockbash along with the real pool price
    return useQuery({
    queryKey: ['shortTermForecast'], 
    queryFn: async () => appApi.queryShortTermPPandRB(),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
}
export const useHCF = () => { // this grabs the current days forecast for both aeso and rockbash along with the real pool price
    return useQuery({
    queryKey: ['HCF'], 
    queryFn: async () => appApi.queryHCFApi(),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
}
export const useHistoricalForecast = () => { //grabs historical 168 hours of the forecasts and pool price
    return useQuery({
    queryKey: ['PPandRB'], 
    queryFn: async () => appApi.queryPPandRB(),
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2 // retry 2 times
  });
}

export const useMarginalCost = (plant, customerId) => { //grabs historical 168 hours of the forecasts and pool price
    const resolvedPlant = resolvePlant(plant);
    const resolvedCustomerId = resolveCustomerId(customerId);
    return useQuery({
    queryKey: ['MarginalCost', resolvedPlant, resolvedCustomerId],
    staleTime: 1000 * 60 * 5, // 5 minutes till the data is stale
    retry: 2, // retry 2 times
    queryFn: async () => {
      const response = await appApi.querySchedulerBotApi("bidbuilderparams", resolvedPlant, resolvedCustomerId);
      if (!response || typeof response !== "object") {
        return 0;
      }
      return response["marginal_cost"] ?? 0;
    }
  });
}

export const useRevenue = (plant) => { // grabs the data for revenue calculation the TNG by A POWERPLANT and the pool price 
  const resolvedPlant = resolvePlant(plant);
  const resolvedAssetId = resolveAssetId(plant);
  return useQuery({
    queryKey: ['Revenue', resolvedPlant, resolvedAssetId], 
    queryFn: async () => {
      try {
        const { start, end } = getMonthToDateRange();
        const [meteredVolumeResponse, poolPriceRaw] = await Promise.all([
          appApi.queryAesoMeteredVolumeDetailsApi(start, end, resolvedAssetId),
          appApi.queryDataApi(`?type=data&db=tbd&table=historicalpoolprice&start=${start}&end=${end}`),
        ]);

        const meteredRows = parseMeteredVolumeRows(meteredVolumeResponse, resolvedAssetId);
        const poolPriceRows = parseHistoricalPoolPriceRows(poolPriceRaw);
        const combinedRows = combineMeteredVolumeWithPoolPrice(meteredRows, poolPriceRows);

        if (combinedRows.length > 0) {
          return combinedRows;
        }

        // Fallback to legacy revenue API if no metered rows are returned.
        const revenuePlant = resolveRevenuePlant(plant);
        const legacyResponse = await appApi.grabRevenue(revenuePlant, resolvedPlant);
        if (!legacyResponse) return null;
        return legacyResponse.body ?? legacyResponse;
      } catch (error) {
        console.error("useRevenue error:", error);
        try {
          const revenuePlant = resolveRevenuePlant(plant);
          const legacyResponse = await appApi.grabRevenue(revenuePlant, resolvedPlant);
          if (!legacyResponse) return null;
          return legacyResponse.body ?? legacyResponse;
        } catch (legacyError) {
          console.error("useRevenue legacy fallback error:", legacyError);
          return null;
        }
      }
    },
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};

export const useRenewableForecast = () => { //currently not being used but grabs the renewable forecast as a webhook as we are doing in Dump[4]
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchForecast = async () => {
      setIsPending(true);
      setError(null);

      try {
        const raw = await appApi.queryDataApi(
          `?type=data&db=tbd&table=renewableforecast&start=${getDate(-1)}&end=${getDate(8)}`
        );

        if (raw !== undefined && raw !== null) {
          const parsed = JSON.parse(raw).data;
          const data2 = timeSelect(parsed, 0, 0, 168);
          const data1 = timeSelect(parsed, 0, -6, 12);

          const formatted = {
            solar: data1.map(row => row[2]),
            wind: data1.map(row => row[6]),
            time: data1.map(row => row[0]),
            solar168: data2.map(row => row[2]),
            wind168: data2.map(row => row[6]),
            time168: data2.map(row => row[0]),
          };

          localStorage.setItem('4', JSON.stringify(formatted));
          setData(formatted);
        } else {
          setError('No data returned');
        }
      } catch (err) {
        setError(err.message || 'Unknown error');
      } finally {
        setIsPending(false);
      }
    };

    fetchForecast();
  }, []);

  return { data, isPending, error };
};


export const useWeeklyPeakLoadForecast = () => {
  return useQuery({
    queryKey: ['WeeklyPeakLoadForecast'],
    queryFn: async () => {
      const res = await appApi.queryDataApi(`?type=data&db=tbd&table=weeklypeakloadforecast&start=${getDate(0)}&end=${getDate(8)}`);
      if (!res) throw new Error("No response from weekly peak load forecast API");

      const parsed = JSON.parse(res);
      const formattedData = parsed.data.map(data => ({
        datetime: data[0],
        peakDemand: data[2],
        demand: data[1],
      }));

      return formattedData;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  });
};
export const useRevenueMonthly = () => {
  const { start, end } = getPast12MonthRange();

  return useQuery({
    queryKey: ['RevenueMonthly', start, end],
    queryFn: async () => {
      const rawData = await appApi.queryDataApi(`?type=data&db=tbd&table=quantify_revenuemonthly&start=${start}&end=${end}`);
      if (!rawData) throw new Error('No data returned from queryDataApi');

      const parsed = JSON.parse(rawData);
      if (!parsed?.data) throw new Error('Malformed response');

      return parsed.data.map((data) => ({
        datetime: data[0],
        wisdm_revenue: data[1],
        customer_revenue: data[2],
        asset: data[3],
      }));
    },
    staleTime: 1000 * 60 * 10,
    retry: 2,
  });
};
